import { Component } from '@angular/core';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent {

  /**
   * Not using for the moment,
   * Initially plan was to make it redirect to home page.
   * For now, if the url not found automatically redirects to landing page
   */
  public goToHome() { }

}
